import React, { useEffect } from 'react';

import BreederProfileTabContent from 'dpl/components/BreederProfile/Show/BreederProfileTabContent';
import BreederProfileTabs from 'dpl/components/BreederProfile/Show/BreederProfileTabs';
import BreederProfileHeader from 'dpl/components/BreederProfile/mobile/components/BreederProfileHeader';
import useBreederProfileMobileLayout from 'dpl/components/BreederProfile/hooks/useBreederProfileMobileLayout';

export default function BreederProfileLayoutContainer() {
  const { isNewMobileLayout } = useBreederProfileMobileLayout();

  useEffect(() => {
    if (!isNewMobileLayout) return;

    const mobileHeader = document.querySelector('#mainHeader .MobileHeader');

    if (!mobileHeader) return;

    // Background color override in new mobile layout
    mobileHeader.style.backgroundColor = '#faf7f2';
  }, [isNewMobileLayout]);

  return (
    <div className="BreederProfileLayoutContainer">
      <BreederProfileHeader />
      <BreederProfileTabs />
      <BreederProfileTabContent />
    </div>
  );
}
